import { Component, input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  standalone: true,
  template: `
    <div class="loader-container">
      <div class="spinner"></div>
      <p>{{ message() }}</p>
    </div>
  `,
  styleUrl: './spinner.scss'
})
export class Spinner {
  message = input<string>('Caricamento in corso...');
}